import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, A11y, Pagination } from "swiper";
import notification from "img/pop-up/notification.svg";
import offline from "img/pop-up/offline.svg";
import phone from "img/pop-up/phone.svg";

import "../sass/app-pop-up.scss";
import "swiper/css/pagination";
import "swiper/css";
import {
  APPLE_APP_STORE_URL,
  GOOGLE_PLAY_STORE_URL,
} from "components/AppStoreUtil";
import {
  isFeatureEnabled,
  DISMISS_CONTINUE_IN_APP,
  enableFeature,
} from "components/Features";
import { IS_PROD_STAGE } from "api-config";
SwiperCore.use([Autoplay, A11y, Pagination]);

const AppPopUp = () => {
  const isContinueInAppNotificationDismissed = isFeatureEnabled(
    DISMISS_CONTINUE_IN_APP
  );
  const [dismissAppPopUp, setDismissAppPopUp] = useState(
    isContinueInAppNotificationDismissed
  );

  const getAppStoreUrl = () => {
    if (typeof window === "undefined") {
      return "#"; // Should not happen
    }
    const { navigator } = window;
    if (
      typeof navigator !== "undefined" &&
      navigator.userAgent.indexOf("iPhone OS") !== -1
    ) {
      return APPLE_APP_STORE_URL;
    } else if (
      typeof navigator !== "undefined" &&
      navigator.userAgent.indexOf("Android") !== -1
    ) {
      return GOOGLE_PLAY_STORE_URL;
    }
    return "#"; // Should not happen
  };

  const onContinueInBrowserButtonClicked = () => {
    setDismissAppPopUp(true);
    enableFeature(DISMISS_CONTINUE_IN_APP);
  };

  const appStoreUrl = getAppStoreUrl();

  document.body.classList.add("overflow-hidden");
  let mobileBottomNav = document.querySelector(".mobile-bottom-nav");

  if (dismissAppPopUp || IS_PROD_STAGE) {
    document.body.classList.remove("overflow-hidden");
    mobileBottomNav.classList.remove("d-none");
    return <></>;
  }

  return (
    <div className="popup-container">
      <div className="popup-block">
        <Swiper
          className="swiper popUp-swiper"
          spaceBetween={10}
          slidesPerView={1}
          loop={true}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
          }}
          pagination={{ el: ".swiper-pagination", clickable: true }}
        >
          <SwiperSlide className="swiper-slide">
            <div className="popUp-slide">
              <div className="img-container mx-auto">
                <img src={notification} alt="notification bell" />
              </div>
              <p className="text">Get notified on upcoming calls</p>
            </div>
          </SwiperSlide>
          <SwiperSlide className="swiper-slide">
            <div className="popUp-slide">
              <div className="img-container mx-auto">
                <img src={phone} alt="phone" />
              </div>
              <p className="text">More than 20000+ calls</p>
            </div>
          </SwiperSlide>
          <SwiperSlide className="swiper-slide">
            <div className="popUp-slide">
              <div className="img-container mx-auto">
                <img src={offline} alt="offline" />
              </div>
              <p className="text">Listen downloaded calls offline</p>
            </div>
          </SwiperSlide>

          <div className="swiper-pagination"></div>
        </Swiper>

        <div className="link-btn-container">
          <div className="btn-container">
            <a className="btn" href={appStoreUrl}>
              Continue in app
            </a>
          </div>
          {/* at click close the pop-up */}
          <Button
            type="button"
            variant="default"
            className="browser-link p-0 without-focus border-0"
            onClick={onContinueInBrowserButtonClicked}
          >
            Continue in browser
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AppPopUp;
